import { Injectable } from '@angular/core';
import { CanMatch, CanActivate, CanActivateChild, UrlTree } from '@angular/router';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { filter, tap, map, switchMap, take } from 'rxjs/operators';
import { baseSharedActions, baseSharedSelectors, BaseCoreState } from '../../_store';

@Injectable({ providedIn: 'root' })
export class BaseCountryListGuard implements CanMatch, CanActivate, CanActivateChild {
  constructor(private store: Store<BaseCoreState>) {}

  canMatch() {
    return this.check$();
  }

  canActivate() {
    return this.check$();
  }

  canActivateChild() {
    return this.check$();
  }

  private check$(): Observable<boolean | UrlTree> {
    return this.store.select(baseSharedSelectors.getCountryList).pipe(
      take(1),
      tap((state) => {
        if (state.ok === undefined && !state.data) {
          this.store.dispatch(baseSharedActions.loadCountryList());
        }
      }),
      switchMap(() =>
        this.store.select(baseSharedSelectors.getCountryList).pipe(
          filter((state) => state.ok !== undefined),
          take(1),
          map((state) => !!state.ok)
        )
      )
    );
  }
}
